import ErrorBoundary from "components/ErrorBoundary";
import ReactStrapTable from "components/reactStrapTable";
import React, { useEffect, useState } from "react";
import { CardBody,Card, Container, Row, Col, Table, Input, Button } from "reactstrap";
import { cellRendererCheck } from "utils/columns";
import cancel from "assets/icon/cancel.svg";
import save from "assets/icon/save.svg";



// let downtabledemodata = [         
//      { gpoaccmulations : "5", bprice :"10.00", bAccmulations : "5", packagesize : "200", ndcdescription : "5MG Tablet", ndc :"Type A", gcn : "1173" },
//      { gpoaccmulations : "4", bprice : "12.00", bAccmulations : "1", packagesize :"500", ndcdescription : "5MG Tablet", ndc : "Type B", gcn : "1173" },
//      { gpoaccmulations : "0", bprice :"15.00", bAccmulations :"0", packagesize :"1000", ndcdescription : "5MG Tablet", ndc : "Type C", gcn : "1173" }]

//      let toptabledemodata = [{ accumulations340B : "10", bprice :"$5", btotalspend : "$50", gpoAccmulations : "20", gpoprice :"$20", gpototalspend : "$400" }]
     let downtabledemodata1 = [         
      { gpoaccmulations : "0", bprice :"69.53", bAccmulations : "0", packagesize : "100", ndcdescription : "DIVALPROEX SOD ER 500 MG TAB", ndc :"00378047301", gcn : "46315",elgiable340bpacks:"",gpopricepack:"$133.28",wacpackeges:"",wacprice:"$190.26",acctype:"WAC",total340Bspend:"$1,365.29",totalgpospend:"$1,862.85",totalwacspend:"$3,658.47",totalspend:"$6,886.51" },
      { gpoaccmulations : "0", bprice : "69.49", bAccmulations : "0", packagesize :"500", ndcdescription : "DIVALPROEX SOD ER 500 MG TAB", ndc : "00378047305", gcn : "46315",elgiable340bpacks:"",gpopricepack:"$133.20",wacpackeges:"",wacprice:"$174.27",acctype:"WAC",total340Bspend:"$1,365.29",totalgpospend:"$1,862.85",totalwacspend:"$3658.47",totalspend:"$6,886.51" },
      { gpoaccmulations : "0", bprice :"128.94", bAccmulations :"0", packagesize :"500", ndcdescription : "DIVALPROEX SOD ER 500 MG TAB", ndc : "68001010603", gcn : "46315",elgiable340bpacks:"",gpopricepack:"$116.64",wacpackeges:"",wacprice:"$194.88",acctype:"WAC",total340Bspend:"$1,365.29",totalgpospend:"$1,862.85",totalwacspend:"$3658.47",totalspend:"$6,886.51" },
      { gpoaccmulations : "0", bprice :"8.04", bAccmulations :"30", packagesize :"90", ndcdescription : "DIVALPROEX SOD ER 500 MG TAB", ndc : "43353054760", gcn : "46315",elgiable340bpacks:"",gpopricepack:"$14.72",wacpackeges:"",wacprice:"$22.03",acctype:"340B",total340Bspend:"$1,365.29",totalgpospend:"$1,862.85",totalwacspend:"$3658.47",totalspend:"$6,886.51" },
      { gpoaccmulations : "20", bprice :"39.45", bAccmulations :"10", packagesize :"90", ndcdescription : "DIVALPROEX SOD ER 500 MG TAB", ndc : "43353092860", gcn : "46315",elgiable340bpacks:"",gpopricepack:"$102.45",wacpackeges:"",wacprice:"$248.62",acctype:"GPO",total340Bspend:"$1,365.29",totalgpospend:"$1,862.85",totalwacspend:"$3658.47",totalspend:"$6,886.51" }
    ]
  
      let toptabledemodata1 = [{ accumulations340B : "30",bpackegs:"30", bprice :"$8.04", btotalspend : "$241.20",gpoPkgs:"20", gpoAccumulations : "20", gpoPricePkgs :"$102.45", gpototalspend : "$2,049.00" ,wacdefault:"30",wacprice:"$190.26",wactotal:"$5,707.80"}]
     
     
      let downtabledemodata2 = [         
        { gpoaccmulations : "0", bprice :"51.78", bAccmulations : "0", packagesize : "20", ndcdescription : "ACYCLOVIR 1,000 MG/20 ML VIAL", ndc :"55150015520", gcn : "38954",elgiable340bpacks:"",gpopricepack:"$41.57",wacpackeges:"",wacprice:"$323.33",acctype:"WAC",total340Bspend:"$1,365.29",totalgpospend:"$1,862.85",totalwacspend:"$3658.47",totalspend:"$6,886.51"  },
        { gpoaccmulations : "0", bprice : "58.19", bAccmulations : "0", packagesize :"20", ndcdescription : "ACYCLOVIR 1,000 MG/20 ML VIAL", ndc : "63323032520", gcn : "38954",elgiable340bpacks:"",gpopricepack:"$194.00",wacpackeges:"",wacprice:"$194.00",acctype:"WAC",total340Bspend:"$1,365.29",totalgpospend:"$1,862.85",totalwacspend:"$3658.47",totalspend:"$6,886.51"  },
        { gpoaccmulations : "0", bprice :"44.17", bAccmulations :"0", packagesize :"20", ndcdescription : "ACYCLOVIR 1,000 MG/20 ML VIAL", ndc : "63323032509", gcn : "38954",elgiable340bpacks:"",gpopricepack:"$43.17",wacpackeges:"",wacprice:"$44.50",acctype:"WAC",total340Bspend:"$1,365.29",totalgpospend:"$1,862.85",totalwacspend:"$3658.47",totalspend:"$6,886.51"  },
        { gpoaccmulations : "0", bprice :"34.15", bAccmulations :"20", packagesize :"20", ndcdescription : "ACYCLOVIR 1,000 MG/20 ML VIAL", ndc : "55150015521", gcn : "38954",elgiable340bpacks:"",gpopricepack:"$31.99",wacpackeges:"",wacprice:"$34.40",acctype:"GPO",total340Bspend:"$1,365.29",totalgpospend:"$1,862.85",totalwacspend:"$3658.47",totalspend:"$6,886.51" },
        { gpoaccmulations : "10", bprice :"29.48", bAccmulations :"0", packagesize :"20", ndcdescription : "ACYCLOVIR 1,000 MG/20 ML VIAL", ndc : "55150015521", gcn : "38954",elgiable340bpacks:"",gpopricepack:"$68.23",wacpackeges:"",wacprice:"$82.41",acctype:"340B",total340Bspend:"$1,365.29",totalgpospend:"$1,862.85",totalwacspend:"$3658.47",totalspend:"$6,886.51" }
      ]

    
        let toptabledemodata2 = [{ accumulations340B : "20",bpackegs:"20", bprice :"$34.15", btotalspend : "$683.00", gpoPkgs:"10", gpoAccumulations : "10", gpoPricePkgs :"$68.23", gpototalspend : "$682.30",wacdefault:"30",wacprice:"$82.41",wactotal:"$2,472.30" }]
      
      
      
        let downtabledemodata3 = [        
          { gpoaccmulations : "0", bprice :"4.42", bAccmulations : "10", packagesize : "3.5", ndcdescription : "ERYTHROMYCIN EYE OINTMENT 5MG/GM", ndc :"24208091055", gcn : "7948",elgiable340bpacks:"",gpopricepack:"$9.90",wacpackeges:"",wacprice:"$15.19",acctype:"340B",total340Bspend:"$1,365.29",totalgpospend:"$1,862.85",totalwacspend:"$3658.47",totalspend:"$6,886.51" },
          { gpoaccmulations : "0", bprice : "71.45", bAccmulations : "0", packagesize :"3.5", ndcdescription : "ERYTHROMYCIN EYE OINTMENT 5MG/GM", ndc : "24208091019", gcn : "7948",elgiable340bpacks:"",gpopricepack:"$384.06",wacpackeges:"",wacprice:"$454.80",acctype:"WAC",total340Bspend:"$1,365.29",totalgpospend:"$1,862.85",totalwacspend:"$3658.47",totalspend:"$6,886.51" },
          { gpoaccmulations : "0", bprice :"55.22", bAccmulations :"0", packagesize :"3.5", ndcdescription : "ERYTHROMYCIN EYE OINTMENT 5MG/GM", ndc : "72485067031", gcn : "7948",elgiable340bpacks:"",gpopricepack:"$184.96",wacpackeges:"",wacprice:"$184.96",acctype:"WAC",total340Bspend:"$1,365.29",totalgpospend:"$1,862.85",totalwacspend:"$3658.47",totalspend:"$6,886.51" }
          ,{ gpoaccmulations : "10", bprice : "9.15", bAccmulations : "0", packagesize :"3.5", ndcdescription : "ERYTHROMYCIN EYE OINTMENT 5MG/GM", ndc : "24208091055", gcn : "7948",elgiable340bpacks:"",gpopricepack:"$9.90",wacpackeges:"",wacprice:"$15.19",acctype:"GPO",total340Bspend:"$1,365.29",totalgpospend:"$1,862.85",totalwacspend:"$3658.47",totalspend:"$6,886.51" },
          ,{ gpoaccmulations : "0", bprice :"5.00", bAccmulations :"0", packagesize :"3.5", ndcdescription : "ERYTHROMYCIN EYE OINTMENT 5MG/GM", ndc : "24208091055", gcn : "7948",elgiable340bpacks:"",gpopricepack:"$10.16",wacpackeges:"",wacprice:"$14.08",acctype:"WAC",total340Bspend:"$1,365.29",totalgpospend:"$1,862.85",totalwacspend:"$3658.47",totalspend:"$6,886.51" }]
       
          let toptabledemodata3 = [{ accumulations340B : "10",bpackegs:"10", bprice :"$4.42", btotalspend : "$44.20",gpoPkgs:"10", gpoAccumulations : "10", gpoPricePkgs :"$9.90", gpototalspend : "$99.00" ,wacdefault:"20",wacprice:"$184.96",wactotal:"$3,699.20"}] 
const ViewSuuestions = (props)=>{
  debugger;
const {toggleviewsugg,selectedrow} = props;



const [data,setData]= useState([]);
const [data1,setData1]= useState([]);
useEffect(()=>{
  if(selectedrow.ndc==43353054760){
    setData(toptabledemodata1)
    setData1(downtabledemodata1)
  }
  if(selectedrow.ndc==55150015521){
    setData(toptabledemodata2)
    setData1(downtabledemodata2)
  }
  if(selectedrow.ndc==24208091055){
    setData(toptabledemodata3)
    setData1(downtabledemodata3)
  }
},[])



const cellRendererInput = (bpackegs)=>{
  debugger;
return(
    <Input 
  type="text"
  name="elgiable340bpacks"
  defaultValue={bpackegs}
  // defaultValue={bpackegs}

    />
)
}
 let mainCol = [
    
    {
      dataField: "accumulations340B",
      text: "340B Accumulations",
      sort: false,
      width: 160,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.accumulations340B),
    },
    {
      dataField: "bpackegs",
      text: "340B Packages",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererInput(row.bpackegs),
    },
    {
      dataField: "bprice",
      text: "340B Price",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.bprice),
    },
    {
      dataField: "btotalspend",
      text: "340B Total Spend",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.btotalspend),
    },
    {
        dataField: "gpoAccumulations",
        text: "GPO Accumulations",
        sort: false,
        width: 140,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererCheck(row.gpoAccumulations),
      },
      {
        dataField: "gpoPkgs",
        text: "GPO Packages",
        sort: false,
        width: 140,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererInput(row.gpoPkgs),
      },
      {
        dataField: "gpoPricePkgs",
        text: "GPO Price",
        sort: false,
        width: 140,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererCheck(row.gpoPricePkgs),
      },
      {
        dataField: "gpototalspend",
        text: "GPO Total Spend",
        sort: false,
        width: 140,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererCheck(row.gpototalspend),
      },
      {
        dataField: "wacdefault",
        text: "WAC(Default)",
        sort: false,
        width: 140,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererInput(row.wacdefault),
      },
      {
        dataField: "wacprice",
        text: "WAC Price",
        sort: false,
        width: 140,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererInput(row.wacprice),
      },
      {
        dataField: "wactotal",
        text: "WAC Total Spend",
        sort: false,
        width: 140,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererInput(row.wactotal),
      },
    
   
  ];
  let mainCol1 = [

    {
      dataField: "gcn",
      text: "GCN",
      sort: false,
      width: 100,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.gcn),
    },
    {
      dataField: "ndc",
      text: "NDC",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.ndc),
    },
    {
      dataField: "ndcdescription",
      text: "NDC Description",
      sort: false,
      width: 220,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.ndcdescription),
    },
    {
      dataField: "packagesize",
      text: "Package Size",
      sort: false,
      width: 140,
      show: true,
      inputType: "text",
      hideColFilter: true,
      cellRenderer: (row) => cellRendererCheck(row.packagesize),
    },
    {
        dataField: "bAccmulations",
        text: "340B Accumulations",
        sort: false,
        width: 140,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererCheck(row.bAccmulations),
      },
      {
        dataField: "elgiable340bpacks",
        text: " Eligible 340B Packs",
        sort: false,
        width: 140,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererInput(row.elgiable340bpacks),
      },
      {
        dataField: "bprice",
        text: "340B Price/Pack",
        sort: false,
        width: 140,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererCheck(row.bprice),
      },
      {
        dataField: "gpoaccmulations",
        text: "GPO Accumulations",
        sort: false,
        width: 140,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererCheck(row.gpoaccmulations),
      },
     
      {
        dataField: "elgiable340bpacks",
        text: "Eligible GPO Packs",
        sort: false,
        width: 140,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererInput(row.elgiable340bpacks),
      },
      {
        dataField: "gpopricepack",
        text: "GPO Price/Pack",
        sort: false,
        width: 140,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererCheck(row.gpopricepack),
      },
      {
        dataField: "wacpackeges",
        text: "WAC Packages",
        sort: false,
        width: 140,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererCheck(row.wacpackeges),
      },
      {
        dataField: "wacprice",
        text: "WAC Price/Pack",
        sort: false,
        width: 120,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererCheck(row.wacprice),
      },
      {
        dataField: "acctype",
        text: "Acc Type",
        sort: false,
        width: 140,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererCheck(row.acctype),
      },
      {
        dataField: "total340Bspend",
        text: "Total 340B Spend",
        sort: false,
        width: 120,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererCheck(row.total340Bspend),
      },
      {
        dataField: "totalgpospend",
        text: "Total GPO Spend",
        sort: false,
        width: 120,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererCheck(row.totalgpospend),
      },
      {
        dataField: "totalwacspend",
        text: "Total WAC Spend",
        sort: false,
        width: 120,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererCheck(row.totalwacspend),
      },
      {
        dataField: "totalspend",
        text: "Total Spend",
        sort: false,
        width: 140,
        show: true,
        inputType: "text",
        hideColFilter: true,
        cellRenderer: (row) => cellRendererCheck(row.totalspend),
      },
     
    

  ];
    return(
   <div>
    <Card>
      <CardBody>
     
      <Row>
        <h4 className="f-15 text-primary font-weight-700">Drug Details </h4>
        <hr></hr>
        <Col md="2">
          <p className="m-0 f-14 mt-2">NDC : </p>
          <p className="m-0 f-14 font-weight-500 mt-1">
            {selectedrow.ndc}
            {/* //rowData.accountType == 1001
              // ? "340B"
              // : rowData.accountType == 1002
              // ? "GPO"
              // : "WAC"*/}
          </p> 
        </Col>

        <Col md="2">
          <p className="m-0 f-14 mt-2">NDC Description : </p>
          <p className="m-0 f-14 font-weight-500 mt-1">{selectedrow.drugName}</p>
        </Col>
        <Col md="2">
          <p className="m-0 f-14 mt-2">Package Size : </p>
          <p className="m-0 f-14 font-weight-500 mt-1">
            {'12'}
          </p>
        </Col>
        <Col md="2">
          <p className="m-0 f-14 mt-2">Manufacturer : </p>
          <p className="m-0 f-14 font-weight-500 mt-1">{selectedrow.manufacture
          }</p>
        </Col>
        <Col md="3">
          <p className="m-0 f-14 mt-2">Total Ordered Packages : </p>
          <p className="m-0 f-14 font-weight-500 mt-1">
            {selectedrow.totalpkgs}
          </p>
        </Col>
      
      </Row>
      <hr></hr>
      </CardBody>
      </Card>
      
      <div  className='table-card scroll-table position-relative border-0 rounded pt-0 mt-3'
        fixed-height={data.length > 0 ? 'fixed-height' : 'default'}>
            <ReactStrapTable
             //id="configuration-table"
          height={550}
          fixedColumn
          width={1200}
          // reset={reset}
          data={data}
          columns={mainCol}
          // hasPagination
         // filters={filters}
          //totalRecords={totalitem}
        //   pageSize={10}
        //   currentPage={1}
         
          //collapseSider={collapseSider}
         
                showtoggle={true} />
        </div>
        <Row>
        &nbsp;
        </Row>
        <Row style={{float:"inline-end"}}>
        <p style={{color:"#212121",fontSize:"20px",fontWeight:"600"}}> <span style={{color:"#9E9E9E",fontSize:"14px"}}>Total Spend: </span>{selectedrow.ndc==55150015521?"$3837.60":selectedrow.ndc==43353054760?"$7998.00":selectedrow.ndc==24208091055?"$3842.40":""} </p>
        </Row>
        <Row>
        &nbsp;
        </Row>
       <h4 className="f-15 text-primary font-weight-700">Suggestions</h4>
        <hr></hr>
        <div  className='table-card scroll-table position-relative border-0 rounded pt-0'
        fixed-height={data1.length > 0 ? 'fixed-height' : 'default'}>
            <ReactStrapTable
           //  id="configuration-table"
          height={550}
          fixedColumn
          width={1200}
          // reset={reset}
          data={data1}
          columns={mainCol1}
          // hasPagination
         // filters={filters}
          //totalRecords={totalitem}
        //   pageSize={10}
        //   currentPage={1}
         
          //collapseSider={collapseSider}
         
                showtoggle={true} />
        </div>
        <Row>
            &nbsp;
        </Row>
       <Row style={{float:"inline-end"}}>
       <p  style={{color:"#212121",fontSize:"20px",fontWeight:"600"}}> <span style={{color:"#9E9E9E",fontSize:"14px"}}>Total Spend: </span>{"$34433.05"} </p>
       </Row>
      <Row>
      &nbsp;
      </Row>
     
      <Row>
      &nbsp;
      </Row>
      <Row style={{float:"inline-end"}}>
      <p style={{color:"#212121",fontSize:"20px",fontWeight:"600"}}>  <span style={{color:"#9E9E9E",fontSize:"14px"}}>Suggestions Savings:  </span>{'-'} </p>
      </Row>
      <Row>
      &nbsp;
      </Row>
      <Row>
      &nbsp;
      </Row>
      <div  style={{float:"inline-end"}} >
      <Button color="primary" className="reset"  onClick={toggleviewsugg}>                            
            <span className="right_5">
                                        <img src={cancel} alt="" />
                                      </span>
                                     {" "}  Cancel</Button>{' '}
      <Button color="primary" className="search"   onClick={toggleviewsugg}>  <span className="right_5">
                                        <img src={save} alt="" />
                                      </span> Submit Changes</Button>{' '}
          
      </div>
        
        
   </div>
    )
}
export default ViewSuuestions;